export default __webpack_public_path__ + "static/media/mobile.41348e4b.png";